import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async inscritosSolicitudesPagosConsolidadosRaw(opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos('programa-universidad-pdf/inscritos-solicitudes-pagos-consolidados-raw'),
      {
        params: opciones.params,
        responseType: 'arraybuffer',
      },
    );
  },
};
